export default "__VITE_ASSET__CghBTQGR__"